import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu'
import { Icon } from 'antd';
import {NavLink} from 'react-router-dom'

import ButtonCustom from './default/ButtonCustom'
import TopBar from './TopBar'

class Header extends Component {
    constructor (props) {
        super(props)
        this.state = {
            menuOpen: false,
            searchText: ''
        }
    }
    handleStateChange (state) {
        this.setState({menuOpen: state.isOpen})  
    }
    closeMenu() {
        this.setState({menuOpen: false})
    }
    toggleMenu() {
        this.setState({menuOpen: !this.state.menuOpen})
    }
    handleSubmit = (event) => {
        event.preventDefault()
        window.location.href = '/search'
    }
    handleChange = (event) => {
        this.setState({searchText: event.target.value})
    }
    render() {
        return (
            <div className="header-wrap">
                <TopBar/>
                <div className="menu-bar-wrap-outer">
                    <div className="menu-bar-wrap is-row">
                        <div className="menu-bar-wrap is-row is-100 ">
                            <div className="menu-right-mobile">
                                <div className="menu-right-wrap">
                                    <Menu 
                                        right
                                        isOpen={this.state.menuOpen}
                                        onStateChange={(state) => this.handleStateChange(state)}
                                    >
                                        <NavLink exact to="/" activeClassName="active" onClick={() => this.closeMenu()}>หน้าแรก</NavLink>
                                        <NavLink to="/innovations" activeClassName="active" onClick={() => this.closeMenu()}>งานวิจัยและนวัตกรรม</NavLink>
                                        <NavLink to="/news" activeClassName="active" onClick={() => this.closeMenu()}>ข่าวสาร</NavLink>
                                        <NavLink to="/webboard" activeClassName="active" onClick={() => this.closeMenu()}>กระดานสนทนา</NavLink>
                                    </Menu>
                                </div>
                                <div className={`menu-right-toggle-button ${this.state.isHide ? 'hide' : ''}`}>
                                    <ButtonCustom
                                        iconButton
                                        color="transparent"
                                        label={<img src="/resources/images/ic-menu.svg" alt="menu" />}
                                        onClick={() => this.toggleMenu()}/>
                                </div>
                            </div>
                            <div className="search-mobile">
                                <ButtonCustom
                                    color="transparent"
                                    label={< Icon type="search" style={{ fontSize: 20, color: 'rgba(0, 0, 0, 0.85)' }}/>}
                                    iconButton
                                    href="/"
                                />
                            </div>
                            <div className="is-desktop is-tablet-hide is-row flex-between is-100 is-h-100">
                                    <ul className="menu-bar">
                                        <li className="menu-bar-item">
                                            <NavLink exact to="/" activeClassName="active">หน้าแรก</NavLink>
                                        </li>
                                        <li className="menu-bar-item">
                                            <NavLink to="/innovations" activeClassName="active">งานวิจัยและนวัตกรรม</NavLink>
                                        </li>
                                        <li className="menu-bar-item">
                                            <NavLink to="/news" activeClassName="active">ข่าวสาร</NavLink>
                                        </li>
                                        <li className="menu-bar-item">
                                            <NavLink to="/webboard" activeClassName="active">กระดานสนทนา</NavLink>
                                        </li>
                                    </ul>
                                    <div className="is-row inner-gapl-12 search-icon">
                                        <div className="vl"></div>
                                        <form onSubmit={this.handleSubmit}>
                                            <input 
                                                type="text" 
                                                className="search-input" 
                                                placeholder="ค้นหา" 
                                                value={this.state.searchText}
                                                onChange={this.handleChange}/>
                                        </form>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
